exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-thumbnail[data-v-66ed59fa]{width:80px}.preview-loading[data-v-66ed59fa]{position:absolute;left:0;top:0;right:0;bottom:0;margin:auto;z-index:2;height:20px}", ""]);

// exports
